function restructureProduct(product) {

  const notifyButton = product.querySelector(".klaviyo-bis-trigger");
  if (notifyButton){
    notifyButton.style.display = "none";
  }

  const hiddenElements = product.querySelectorAll(".off-paper--hidden");
  hiddenElements.forEach(element => {
    element.classList.remove("off-paper--hidden");
  });
  
const productDescriptionMap = {
  "10075589345585": "A skin-like foundation stick that evens out your complexion with buildable coverage that never feels heavy or looks cakey.",
  "10078360305969": "A natural flush of color that starts subtle, builds easily, and lasts all day.",
  "10362418102577": "A velvety-soft powder bronzer that melts in for believable warmth you can build.",
  "10154749821233": "Rich color with real hydration that lasts.",
  "9955323576625":  "Designed for effortless application + blending, use this brush for your cream foundation, concealer, and blush.",
  "10381382746417": "One brush, two jobs: sculpt with the angled end, then flip to buff for a flawless finish of your powder + cream formulas.",
  "10620102574385": "A smudge-proof, waterproof, transfer-proof creamy lip liner that glides on and locks color in place for all-day wear. Built for contouring, lining, and all-over color. Precise definition with no feathering, no bleeding, and no midday checkups.",
};

const title = product.querySelector(".bndlr-product-title");
if (title && !product.querySelector(".bndlr-title-above")) {
  const titleWrapper = document.createElement("div");
  titleWrapper.className = "bndlr-title-above";
  titleWrapper.appendChild(title);
  product.insertBefore(titleWrapper, product.firstChild);
}

const productId = product.getAttribute("data-product-id");
const description = productDescriptionMap[productId];

if (description && !product.querySelector(".bndlr-product-description")) {
  const descriptionElement = document.createElement("div");
  descriptionElement.className = "bndlr-product-description";
  descriptionElement.textContent = description;
  
  const titleWrapper = product.querySelector(".bndlr-title-above");
  if (titleWrapper) {
    titleWrapper.insertAdjacentElement("afterend", descriptionElement);
  }
}

if (!product.querySelector(".bndlr-product-content-wrapper")) {
  const contentWrapper = document.createElement("div");
  contentWrapper.className = "bndlr-product-content-wrapper";

  Array.from(product.children).forEach((child) => {
    if (!child.classList.contains("bndlr-title-above") && 
        !child.classList.contains("bndlr-product-description")) {
      contentWrapper.appendChild(child);
    }
  });

  const descriptionElement = product.querySelector(".bndlr-product-description");
  if (descriptionElement) {
    descriptionElement.insertAdjacentElement("afterend", contentWrapper);
  } else {
    const titleWrapper = product.querySelector(".bndlr-title-above");
    if (titleWrapper) {
      titleWrapper.insertAdjacentElement("afterend", contentWrapper);
    } else {
      product.insertBefore(contentWrapper, product.firstChild);
    }
  }
}

 const swatchMap = {
  "000": {
    color: "#221812",
    legend: "For deep skin with neutral undertones",
  },
  0.5: {
    color: "#372825",
    legend: "For deep skin with neutral undertones.",
  },
  "001": {
    color: "#5D3417",
    legend: "For deep skin with neutral undertones",
  },
  "002": {
    color: "#6C3C1F",
    legend: "For deep skin with cool undertones.",
  },
  "003": {
    color: "#6D3B1E",
    legend: "For deep skin with cool neutral undertones.",
  },
  "004": {
    color: "#744122",
    legend: "For deep skin with cool red undertones.",
  },
  "005": {
    color: "#7B4623",
    legend: "For deep skin with neutral undertones.",
  },
  "006": {
    color: "#7F4A28",
    legend: "For deep skin with cool red undertones.",
  },
  "007": {
    color: "#89512C",
    legend: "For deep skin with warm golden undertones.",
  },
  "008": {
    color: "#915730",
    legend: "For deep skin with warm undertones.",
  },
  "009": {
    color: "#9A5D35",
    legend: "For deep skin with warm golden undertones.",
  },
  "010": {
    color: "#A5663D",
    legend: "For deep skin with very warm undertones.",
  },
  "011": {
    color: "#AE6C43",
    legend: "For tan skin with warm undertones.",
  },
  "012": {
    color: "#B7744B",
    legend: "For tan skin with cool peach undertones.",
  },
  "013": {
    color: "#C17D53",
    legend: "For tan skin with warm undertones.",
  },
  "014": {
    color: "#C98759",
    legend: "For tan skin with neutral undertones.",
  },
  "015": {
    color: "#CF8C5D",
    legend: "For tan skin with warm neutral undertones.",
  },
  "016": {
    color: "#D79565",
    legend: "For tan skin with cool undertones.",
  },
  "017": {
    color: "#DD9D6D",
    legend: "For tan skin with warm golden undertones.",
  },
  "018": {
    color: "#E2A374",
    legend: "For tan skin with cool peach undertones.",
  },
  "019": {
    color: "#E7AA7C",
    legend: "For tan skin with warm undertones.",
  },
  "020": {
    color: "#EBB185",
    legend: "For tan skin with warm golden undertones.",
  },
  "021": {
    color: "#F0B78C",
    legend: "For medium skin with warm olive undertones.",
  },
  "022": {
    color: "#F3BD94",
    legend: "For medium skin with neutral peach undertones.",
  },
  "023": {
    color: "#F7C49D",
    legend: "For medium skin with cool undertones.",
  },
  "024": {
    color: "#FACBA5",
    legend: "For medium skin with neutral undertones.",
  },
  "025": {
    color: "#FCD2AE",
    legend: "For medium skin with warm peach undertones",
  },
  "026": {
    color: "#FFD8B7",
    legend: "For medium skin with warm undertones.",
  },
  "027": {
    color: "#FFDFC0",
    legend: "For medium skin with neutral yellow undertones.",
  },
  "028": {
    color: "#FFE5CA",
    legend: "For medium skin with warm undertones.",
  },
  "029": {
    color: "#FFEBD3",
    legend: "For medium skin with neutral undertones.",
  },
  "030": {
    color: "#FFF1DD",
    legend: "For medium skin with cool undertones.",
  },
  "031": {
    color: "#CE9B77",
    legend: "For light skin with warm undertones.",
  },
  "032": {
    color: "#C39975",
    legend: "For light skin with warm yellow undertones.",
  },
  "033": {
    color: "#C39975",
    legend: "For light skin with cool undertones.",
  },
  "034": {
    color: "#E2BBA0",
    legend: "For light skin with warm peach undertones",
  },
  "035": {
    color: "#EED4B9",
    legend: "For light skin with neutral olive undertones.",
  },
  "036": {
    color: "#FBE3C7",
    legend: "For light skin with warm undertones",
  },
  "037": {
    color: "#F4D4B2",
    legend: "For light skin with warm yellow undertones.",
  },
  "038": {
    color: "#FBE2CB",
    legend: "For light skin with warm neutral undertones.",
  },
  "039": {
    color: "#FCE5D9",
    legend: "For light skin with cool pink undertones.",
  },
  "040": {
    color: "#FCE9DE",
    legend: "For light skin with neutral undertones.",
  },
  "Bubble Gum Pink": {
    color: "#FF8EBB",
    legend: "A cool-toned pink best suited for very fair skin.",
  },
  "Burnt Orange": {
    color: "#E33716",
    legend: "A warm-toned terracotta.",
  },
  "Cherry Red": {
    color: "#CC0010",
    legend: "A warm-toned classic red.",
  },
  Fuchsia: {
    color: "#F81570",
    legend: "A cool-toned hot pink.",
  },
  Mauve: {
    color: "#BA3F3E",
    legend: "A neutral–toned purple-pink.",
  },
  Peach: {
    color: "#EC4C4F",
    legend: "A warm-toned sun-kissed peach.",
  },
  "Pink Yet Coral": {
    color: "#F15861",
    legend: "A warm-toned pinky coral.",
  },
  Nude: {
    color: "#B26761",
    legend: "A warm-toned beige.",
  },
  Raspberry: {
    color: "#E30B5C",
    legend: "A cool-toned pink.",
  },
  Brown: {
    color: "#7C4722",
    legend: "A warm-toned brown.",
  },
  "Shade 01": {
  color: "#B26761",
  legend: "Warm rose nude.",
},
"Shade 02": {
  color: "#9A5C55",
  legend: "Add the correct description here.",
},
"Shade 03": {
  color: "#7C4A43",
  legend: "Add the correct description here.",
},
"Shade 04": {
  color: "#5F3732",
  legend: "Add the correct description here.",
},
  Deep: {
    color: "#72392a",
    legend: "Deep bronze with warm undertones.",
  },
  Tan: {
    color: "#996340",
    legend: "Tan bronze with warm undertones.",
  },
  Medium: {
    color: "#b38569",
    legend: "Medium bronze with warm undertones.",
  },
  Light: {
    color: "#cb9d83",
    legend: "Light bronze with neutral undertones.",
  },
};

  const nonVariantDescriptions = {
    "9955323576625": "",
    "10381382746417": ""
  };

  const dropdowns = product.querySelectorAll("select");
  dropdowns.forEach((select) => {
    if (!select.classList.contains("swatchified")) {
      const productId = product.getAttribute("data-product-id");
      const isNonVariantProduct = nonVariantDescriptions.hasOwnProperty(productId);

      const hasMultipleOptions = Array.from(select.options).filter(option => !option.disabled && option.value).length > 1;
      
      if (isNonVariantProduct && !hasMultipleOptions) {
        // const desc = document.createElement("p");
        // desc.className = "variant-description active bndlr-description-only";
        // desc.textContent = nonVariantDescriptions[productId] || "No description available.";
        
        // select.style.display = "none";
        // select.classList.add("swatchified");
        // select.insertAdjacentElement("afterend", desc);
      } else {
        const fieldset = document.createElement("fieldset");
        fieldset.className =
          "radio__fieldset radio__fieldset--swatches bndlr-swatches";

        const legend = document.createElement("div");
        legend.className = "radio__legend";
        const legendValueSpan = document.createElement("span");
        legendValueSpan.className = "radio__legend__value";
        legendValueSpan.textContent = "Select";

        legend.innerHTML = `
          <div class="radio__legend__label">
            <span class="radio__legend__label--text">
              <span class="radio__legend__option-name">Shade</span>
            </span>
          </div>
        `;
        legend
          .querySelector(".radio__legend__label--text")
          .appendChild(legendValueSpan);

        const desc = document.createElement("p");
        desc.className = "variant-description active";
        desc.textContent = "";
        legend.appendChild(desc);

        fieldset.appendChild(legend);

        const swatchGrid = document.createElement("div");
        swatchGrid.className = "radio__buttons desktop-shade-grid bndlr-buttons";
        swatchGrid.style.display = "flex";
        swatchGrid.style.flexWrap = "wrap";
        swatchGrid.style.gap = "2px";
        fieldset.appendChild(swatchGrid);

        // Changes for TFS to start at 035 | OFF Paper (Oz) | 12-19-2025
        let firstOptionSet = false;
        let defaultVariantId = "50292412907825"; // 035 for TFS

        let defaultOption = null;  
        Array.from(select.options).forEach((option) => {
          if (!option.disabled && option.value) {
            const value = option.textContent.trim();
            const swatchData = swatchMap[value] || {
              color: "#ccc",
              legend: "No description available.",
            };

            const label = document.createElement("label");
              label.className = "swatch__button";
              label.style.width = "36px";  
              label.style.height = "36px";
              label.style.borderRadius = "50%";
              label.style.display = "inline-flex";
              label.style.alignItems = "center";
              label.style.justifyContent = "center";
              label.style.cursor = "pointer";
              label.style.boxSizing = "border-box";
              label.style.border = "2px solid transparent";
              label.style.transition = "border 0.2s";
              label.style.padding = "2px";

              const circle = document.createElement("span");
              circle.style.width = "100%";
              circle.style.height = "100%";
              circle.style.borderRadius = "50%";
              circle.style.backgroundColor = swatchData.color;
              circle.style.display = "block";

              const input = document.createElement("input");
              input.type = "radio";
              input.name = `swatch-${select.name}`;
              input.value = option.value;
              input.style.display = "none";

              input.addEventListener("change", () => {
              select.value = option.value;
              legendValueSpan.textContent = value;
              desc.textContent = swatchData.legend;

            
              swatchGrid.querySelectorAll(".swatch__button").forEach((b) => {
                  b.style.border = "2px solid transparent";
              });

              
              label.style.border = `2px solid ${swatchData.color}`;

              select.dispatchEvent(new Event("change", { bubbles: true }));
              });

              label.appendChild(circle);
              label.appendChild(input);
              swatchGrid.appendChild(label);
              swatchGrid.appendChild(label);

              // Changes for TFS to start at 035 | OFF Paper (Oz) | 12-19-2025
              if (option.value === defaultVariantId) {
                defaultOption = { input, label, value, swatchData };
              }

              if (!firstOptionSet && !defaultOption) {  
                input.checked = true;
                legendValueSpan.textContent = value;
                desc.textContent = swatchData.legend;
                label.style.border = `2px solid ${swatchData.color}`;
                select.value = option.value;
                firstOptionSet = true;
              }
                    
              if (!firstOptionSet) {
              input.checked = true;
              legendValueSpan.textContent = value;
              desc.textContent = swatchData.legend;
              label.style.border = `2px solid ${swatchData.color}`;
              select.value = option.value;
              firstOptionSet = true;
              }
          }
        });
        // Changes for TFS to start at 035 | OFF Paper (Oz) | 12-19-2025
        if (defaultOption) {
          swatchGrid.querySelectorAll(".swatch__button").forEach((b) => {
            b.style.border = "2px solid transparent";
          });
          swatchGrid.querySelectorAll("input[type='radio']").forEach((inp) => {
            inp.checked = false;
          });
          
          defaultOption.input.checked = true;
          legendValueSpan.textContent = defaultOption.value;
          desc.textContent = defaultOption.swatchData.legend;
          defaultOption.label.style.border = `2px solid ${defaultOption.swatchData.color}`;
          select.value = defaultOption.input.value;
        }

        select.style.display = "none";
        select.classList.add("swatchified");
        select.insertAdjacentElement("afterend", fieldset);
      }
    }
  });
}

function handleDynamicElements() {
  const klaviyoButtons = document.querySelectorAll('.klaviyo-bis-trigger:not([data-bndlr-hidden])');
  klaviyoButtons.forEach(button => {
    button.style.display = 'none';
    button.setAttribute('data-bndlr-hidden', 'true');
  });

  const hiddenElements = document.querySelectorAll('.off-paper--hidden');
  hiddenElements.forEach(element => {
    element.classList.remove('off-paper--hidden');
  });
}

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) {
        if (node.matches(".bndlr-product")) {
          restructureProduct(node);
        } else {
          node
            .querySelectorAll(".bndlr-product")
            .forEach((prod) => restructureProduct(prod));
        }
        if (node.matches(".klaviyo-bis-trigger")) {
          node.style.display = "none";
          node.setAttribute('data-bndlr-hidden', 'true');
        }
        
        if (node.matches(".off-paper--hidden")) {
          node.classList.remove("off-paper--hidden");
        } else {
          handleDynamicElements();
        }
      }
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });

document
  .querySelectorAll(".bndlr-product")
  .forEach((prod) => restructureProduct(prod));

handleDynamicElements();

let dynamicElementsInterval = setInterval(() => {
  handleDynamicElements();
}, 1000);

setTimeout(() => {
  clearInterval(dynamicElementsInterval);
}, 30000);